import React, { useState } from "react";
import SendIcon from "@mui/icons-material/Send";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import MKBox from "components/MKBox";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

import routes from "routes";

import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

import { Helmet } from "react-helmet-async";

export default function AfiliaEmpleadosPage() {
  const [empresa, setEmpresa] = useState({
    razonSocial: "",
    nombreFantasia: "",
    direccion: "",
    telefono: "",
    email: "",
    cuit: "",
    documentoTitular: null,
  });

  const [empleados, setEmpleados] = useState([
    {
      nombre: "",
      apellido: "",
      dni: "",
      cuit: "",
      direccion: "",
      fechaIngreso: "",
      fechaSalida: "",
      ddjj: false,
    },
  ]);

  const handleEmpresaChange = (e) => {
    const { name, value, files } = e.target;
    setEmpresa({
      ...empresa,
      [name]: files ? files[0] : value,
    });
  };

  const handleEmpleadoChange = (index, e) => {
    const { name, value, type, checked } = e.target;
    const nuevos = [...empleados];
    nuevos[index][name] = type === "checkbox" ? checked : value;
    setEmpleados(nuevos);
  };

  const agregarEmpleado = () => {
    setEmpleados([
      ...empleados,
      {
        nombre: "",
        apellido: "",
        dni: "",
        cuit: "",
        direccion: "",
        fechaIngreso: "",
        fechaSalida: "",
        ddjj: false,
      },
    ]);
  };

  const eliminarEmpleado = (index) => {
    const nuevos = empleados.filter((_, i) => i !== index);
    setEmpleados(nuevos);
  };

  return (
    <>
      <Helmet>
        <title>Afiliación de Empleados | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Portal de afiliación para empleadores. Realizá el registro de tus empleados en el Sindicato de Panaderos de San Juan de forma rápida y sencilla."
        />

        <meta
          name="keywords"
          content="afiliación empleados, registro trabajadores panadería, sindicato panaderos san juan trámites, alta empleados panadería, beneficios empleadores"
        />

        {/* Open Graph (Redes Sociales) */}
        <meta
          property="og:title"
          content="Afiliación de Empleados - Sindicato Panaderos San Juan"
        />
        <meta
          property="og:description"
          content="Gestioná la afiliación de tus trabajadores y accedé a los beneficios del sindicato."
        />
        <meta property="og:type" content="website" />

        {/* Canonical: Evita contenido duplicado para Google */}
        <link rel="canonical" href="http://sindicatopanaderossanjuan.com.ar/registratrabajadores" />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />

      <MKBox bgColor="white">
        {/* Top Banner */}
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://bakersmachinery.com/wp-content/uploads/2024/01/discover-the-famous-master-bakers.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />
      </MKBox>
      <Box sx={{ maxWidth: 1000, mx: "auto", p: 3 }}>
        {/* Encabezado */}
        <Typography variant="h4" fontWeight="bold" mb={1}>
          Afilia tus trabajadores al sindicato
        </Typography>
        <Box sx={{ width: "100%", height: "3px", backgroundColor: "#2196f3", mb: 4 }} />

        {/* FORMULARIO DE EMPRESA */}
        <Paper sx={{ p: 3, mb: 4 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Datos de la Empresa
          </Typography>

          <TextField
            fullWidth
            margin="normal"
            label="Razón Social"
            name="razonSocial"
            value={empresa.razonSocial}
            onChange={handleEmpresaChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Nombre de fantasía"
            name="nombreFantasia"
            value={empresa.nombreFantasia}
            onChange={handleEmpresaChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Dirección"
            name="direccion"
            value={empresa.direccion}
            onChange={handleEmpresaChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Teléfono"
            name="telefono"
            value={empresa.telefono}
            onChange={handleEmpresaChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="Email"
            name="email"
            value={empresa.email}
            onChange={handleEmpresaChange}
          />
          <TextField
            fullWidth
            margin="normal"
            label="CUIT"
            name="cuit"
            value={empresa.cuit}
            onChange={handleEmpresaChange}
          />

          {/* Documento del titular / Acta de constatación */}
          <Box mt={2}>
            <Typography fontWeight="bold" mb={1}>
              Documento del titular o Acta de constitución
            </Typography>
            <input type="file" name="documentoTitular" onChange={handleEmpresaChange} />
          </Box>
        </Paper>

        {/* FORMULARIOS DE EMPLEADOS */}
        {empleados.map((emp, i) => (
          <Paper key={i} sx={{ p: 3, mb: 3 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h6" fontWeight="bold">
                Empleado {i + 1}
              </Typography>
              {empleados.length > 1 && (
                <IconButton color="error" onClick={() => eliminarEmpleado(i)}>
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>

            <TextField
              fullWidth
              margin="normal"
              label="Nombre"
              name="nombre"
              value={emp.nombre}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Apellido"
              name="apellido"
              value={emp.apellido}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />
            <TextField
              fullWidth
              margin="normal"
              label="DNI"
              name="dni"
              value={emp.dni}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />
            <TextField
              fullWidth
              margin="normal"
              label="CUIT"
              name="cuit"
              value={emp.cuit}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Dirección"
              name="direccion"
              value={emp.direccion}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />
            <TextField
              fullWidth
              margin="normal"
              type="date"
              label="Fecha de ingreso"
              name="fechaIngreso"
              InputLabelProps={{ shrink: true }}
              value={emp.fechaIngreso}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />

            <TextField
              fullWidth
              margin="normal"
              type="date"
              label="Fecha de salida (opcional)"
              name="fechaSalida"
              InputLabelProps={{ shrink: true }}
              value={emp.fechaSalida}
              onChange={(e) => handleEmpleadoChange(i, e)}
            />

            <FormControlLabel
              control={
                <Checkbox
                  checked={emp.ddjj}
                  name="ddjj"
                  onChange={(e) => handleEmpleadoChange(i, e)}
                />
              }
              label="Este formulario tiene carácter de declaración jurada"
            />
          </Paper>
        ))}

        <Button variant="contained" onClick={agregarEmpleado} sx={{ mb: 3 }}>
          Agregar empleado
        </Button>
        <Box>
          <Button
            size="large"
            variant="outlined"
            endIcon={<SendIcon />}
            sx={{
              color: "#000000",
              width: "100%",
            }}
          >
            Enviar Formulario
          </Button>
        </Box>
      </Box>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}
